<template>
<d-container fluid class="main-content-container h-100 px-4 container-fluid">
        <div class="row h-100 no-gutters">
            <div class="auth-form mx-auto my-auto col-md-5 col-lg-3">
                <div class="card">
                <div class="card-body">
                    <img src="@/assets/images/shards-dashboards-logo.svg" alt="Shards Dashboards - Change Password Template" class="auth-form__logo d-table mx-auto mb-3">
                    <h5 class="auth-form__title text-center mb-4">Change Password</h5>
                    <form class="">
                        <div class="form-group">
                            <label for="exampleInputPassword2">New Password</label>
                            <input id="exampleInputPassword2" type="password" v-model="currentPassword" placeholder="Password" class="form-control">
                        </div>
                        <div class="form-group mb-4">
                            <label for="exampleInputPassword3">Confirm Password</label>
                            <input id="exampleInputPassword3" type="password" v-model="confirmPassword" placeholder="Confirm Password" class="form-control">
                        </div>
                        <button type="submit" @click.prevent="changePassword()" class="btn btn-pill btn-accent d-table mx-auto">Change Password</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
  </d-container>
</template>

<script>
import axios from "axios";

export default {
  props: ["otp", "email"],
  data() {
    return {
      password: "",
      currentPassword: "",
      confirmPassword: "",
    };
  },
  methods: {
    changePassword() {
      if(this.currentPassword == this.confirmPassword){
      axios
        .put(process.env.VUE_APP_SERVICE_URL+'api/auth/User/reset-password/' + this.$route.params.email, {
          newPassword: this.confirmPassword,
          otp: this.$route.params.otp
        })
        .then(response => {
          alert(response.data);
        })
        .catch(err => {
          alert(err);
        });
      } else {
        alert('Password does not match')
      }
    },
  },
};
</script>